module.exports = __webpack_public_path__ + "static/media/expYellow.cc302dc1.svg";